<template>
  <div class="template-detail-body">
    <div class="ccui-app-container-detail2">
      <div class="ccui-app-container-detail-body">
        <!-- 公告 -->
        <el-group-title :title="$t('page.content.Explianation1')">
          <template slot="groupTitle">
            <div class="tip">
              <!-- 公告标题： -->
              <p class="tip-title">
                {{ $t("page.content.Title") }}：{{ sscNoticeBO.noticeTitle }}
              </p>
              <!-- 公告内容： -->
              <p>
                {{ $t("page.content.Content") }}：<span
                  v-html="sscNoticeBO.textInfo"
                  class="ccui-clearfix rich-text"
                ></span>
              </p>
            </div>
          </template>
        </el-group-title>
        <!-- 附件列表 -->
        <detailBaseTable
          :title="$t('page.content.Attachments')"
          :table-head="tableChangeHistoryHead"
          :table-data="tableChangeHistoryData"
        >
          <!-- 操作 -->
          <template
            :slot="$t('page.content.operation')"
            slot-scope="{ row, $index }"
          >
            <!-- 下载 -->
            <el-button
              size="mini"
              type="text"
              @click="downloadUrlFile(row, $index)"
            >
              {{ $t("page.content.Download") }}
            </el-button>
            <!-- 预览 -->
            <el-button size="mini" type="text" @click="preview(row)">
              {{ $t("page.content.Yulan") }}
            </el-button>
          </template>
        </detailBaseTable>
      </div>
    </div>
  </div>
</template>
<script>
import { getPreviewUrl } from "@/basa/utils";
import { qryNoticeDetailSub } from "@/app/myProjects/api/myProjectsEl.js";
import { addUrlPerFix } from "@/basa/utils";
export default {
  name: "tendereeAnswerDetailsSub",
  data() {
    return {
      sscNoticeBO: {
        noticeTitle: "",
        noticeId: "",
        noticeStartTime: ""
      },
      agentId: "",
      schemeId: "",
      // 附件列表
      tableChangeHistoryHead: [
        { label: this.$t("page.content.name"), prop: "fileName" }, //附件名称
        { label: this.$t("page.content.Description"), prop: "fileSumm" }, //附件说明
        {
          label: this.$t("page.content.operation"),
          prop: "option",
          slot: this.$t("page.content.operation"),
          width: "100"
        } //操作
      ],
      tableChangeHistoryData: []
    };
  },
  mounted() {
    this.agentId = this.$router.history.current.query.a;
    this.schemeId = sessionStorage.getItem("schemeId");
    this.getNoticeDetail();
  },
  methods: {
    //公告详情
    getNoticeDetail() {
      let param = {};
      Object.assign(
        param,
        { schemeId: this.schemeId },
        { agentId: this.agentId },
        { noticeId: this.$route_query.noticeId },
        { qryFileFlag: true }
      );
      qryNoticeDetailSub(param).then(res => {
        if (res) {
          this.sscNoticeBO = res.data.data;
          this.tableChangeHistoryData = this.sscNoticeBO.fileinfoBOS;
          console.log(res, "res");
        }
      });
    },
    // 下载含有url的文件
    downloadUrlFile(row) {
      let openUrl = document.createElement("a");
      openUrl.style.display = "none";
      openUrl.href = `${addUrlPerFix(
        process.env.VUE_APP_BASE_URL
      )}/apis/bid-scp/oss/downloadByUploadId?uploadId=${row.uploadId}`;
      openUrl.setAttribute("download", row.fileName);
      document.body.appendChild(openUrl);
      openUrl.click();
    },
    //预览
    preview({ fileUrl }) {
      getPreviewUrl(fileUrl);
      //const previewSrc = getPreviewUrl(fileUrl);
      //window.open(previewSrc);
    }
  }
};
</script>
<style lang="scss" scoped>
.mt {
  margin-top: 20px;
}
.tip {
  padding-left: 20px;
  color: #4a4a4a;
  font-size: 13px;
  .tip-title {
    margin-bottom: 20px;
  }
}
.supplierHead {
  position: relative;
  display: flex;
  height: 120px;
  background: #ffffff;
  border-bottom: 1px solid #f1eeee;
  .myBook {
    height: 30px;
    position: absolute;
    top: 28px;
    left: 20px;
  }
  .supplierHead-title {
    padding: 20px 60px;
    .chlidName {
      margin-top: 10px;
      color: #999999;
      font-size: 16px;
      span {
        margin-right: 40px;
      }
    }
    .timeLeft {
      font-size: 14px;
      color: #999999;
      span {
        font-size: 16px;
        color: #ff142f;
      }
    }
    .cutOffTime {
      font-size: 14px;
      color: #999999;
      margin-left: 400px;
      span {
        color: #4a4a4a;
        font-size: 16px;
      }
    }
  }
}
</style>
